import PropTypes from 'prop-types';
import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import InputLabel from '@material-ui/core/InputLabel';
import { FormControl } from '@material-ui/core';
import { configOperations } from '../../redux/config';
import { resourceOperations } from '../../redux/resource';

/**
 * The Select component that lists and sets the dispatch to display.
 */
const DispatchSelect = ({
  currentDispatchID,
  dispatchOptions,
  setCurrentDispatchID
}) => (
  <FormControl style={{minWidth:'150px'}}>
    <InputLabel>Select Dispatch</InputLabel>
    <Select
      value={currentDispatchID}
      onChange={setCurrentDispatchID}
    >
      {dispatchOptions.map(({ id, name }) => (
        <MenuItem value={id} key={`menu-item-${id}`}>
          {name}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
DispatchSelect.propTypes = {
  /**
   * The ID of the current dispatch.
   */
  currentDispatchID: PropTypes.string,
  /**
   * The array dispatches used to populate the select.
   */
  dispatchOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    })
  ),
  /**
   * The handler for when the select onChange.
   */
  setCurrentDispatchID: PropTypes.func
};

DispatchSelect.defaultProps = {
  currentDispatchID: 'a1',
  dispatchOptions: [{ id: 'a1', name: 'Loading dispatches...' }],
  setCurrentDispatchID: () => {
    console.log('Loading dispatches...');
    console.log(this.state.resource.currentDispatchID);
  }
};

export default DispatchSelect;



// WEBPACK FOOTER //
// ./src/components/dispatches/DispatchSelect.js